import { getFirebase } from 'firestorter';
import { firestorePaths } from '../../utils/paths';
import BaseDocument from '../../Model/BaseDocument';
import { ColorModes } from '../../Model/Coach';

class AppCustomization extends BaseDocument {
  constructor(id, opts) {
    super(`${firestorePaths.APP_CUSTOMIZATION}/${id}`, opts);
  }

  get texts() {
    return this.data.texts || {};
  }

  get appIconName() {
    return this.data.appIconName;
  }

  get webAppIconRef() {
    return this.data.webAppIconRef;
  }

  get theme() {
    return this.data.theme || {};
  }

  get baseTheme() {
    return this.theme.baseTheme;
  }

  get primaryColor() {
    return this.theme.colors?.base?.primary || '';
  }

  // The mobile app's color mode (`ColorModes`). The app is dark for a coach who has none.
  get colorMode() {
    return this.theme.colorMode || ColorModes.DARK;
  }

  get welcomeMessage() {
    return this.data.welcomeMessage || '';
  }

  get welcomeMessageAttachments() {
    return this.data.welcomeMessageAttachments || [];
  }

  get onboardingMessages() {
    return this.data.onboardingMessages || [];
  }

  get coach() {
    return this.data.coach;
  }

  get aiWelcomeMessageAttachments() {
    return this.data.aiWelcomeMessageAttachments || [];
  }

  // TODO: Refactor this when we add checkout page customization
  // WARNING: This is a temporary solution to handle checkout page customization for a specific coach.
  get isWorkoutEnabled() {
    return typeof this.data.isWorkoutEnabled === 'boolean' ? this.data.isWorkoutEnabled : true;
  }

  // TODO: Refactor this when we add checkout page customization
  // WARNING: This is a temporary solution to handle the British spelling for a specific coach.
  get useBritishSpelling() {
    return typeof this.data.useBritishSpelling === 'boolean' ? this.data.useBritishSpelling : false;
  }

  async setBaseTheme(baseTheme, lastUpdatedByUserName) {
    return this.updateFields({
      'theme.baseTheme': baseTheme,
      lastUpdatedByUserName,
    });
  }

  async setPrimaryColor(primaryColor, lastUpdatedByUserName) {
    return this.updateFields({
      'theme.colors.base.primary': primaryColor,
      lastUpdatedByUserName,
    });
  }

  async setColorMode(colorMode, lastUpdatedByUserName) {
    return this.updateFields({
      'theme.colorMode': colorMode,
      lastUpdatedByUserName,
    });
  }

  async setWelcomeMessage(message) {
    await this.updateFields({
      welcomeMessage: message || getFirebase().firestore.FieldValue.delete(),
    });
  }

  async setWelcomeMessageAttachments(attachments) {
    await this.updateFields({
      welcomeMessageAttachments: attachments || getFirebase().firestore.FieldValue.delete(),
    });
  }

  async setOnboardingMessages(messages) {
    const normalized = (messages || []).map((m) => ({
      enabled: !!m.enabled,
      message: m.message || '',
      attachments: m.attachments || [],
    }));
    await this.updateFields({
      onboardingMessages: normalized,
    });
  }

  async setAIWelcomeMessageAttachments(attachments) {
    await this.updateFields({
      aiWelcomeMessageAttachments: attachments || getFirebase().firestore.FieldValue.delete(),
    });
  }

  static getAppCustomizationByCoach = async (coachId) => {
    const appCustomizationDoc = new AppCustomization(coachId);
    await appCustomizationDoc.init();
    return appCustomizationDoc.exists ? appCustomizationDoc : null;
  };
}

export default AppCustomization;
